<template>
  <Modal v-if="showModal" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="addDescription">
      <div class="addDescription__header">
        <span class="title">{{ $t('addDescription') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="addDescription__body">
        <div class="container">
          <GeneralInfoReservation
            :isAddDescription="true"
            :openGeneralInfoReservation="openGeneralInfoReservation"
            :activeDelivery="activeDelivery"
          />
          <div class="addDescription__body-description">
            <FormKit
              type="form"
              id="description-form"
              v-model="formData"
              :actions="false"
              @submit="submitHandler"
            >
              <label class="label-description" for="description">
                {{ $t('description') }}
              </label>
              <textarea
                v-model="activeDelivery.descriptionText"
                id="description"
                class="input-description"
                maxlength="250"
              >
              </textarea>
            </FormKit>
          </div>
        </div>
        <InfoAboutActionLog
          v-if="openInfoAboutActionLog"
          :activeDelivery="activeDelivery"
        />
      </div>
      <div class="addDescription__buttons">
        <Button
          v-if="activeDelivery.actionsLog"
          variant="filled"
          :title="
            $t(openInfoAboutActionLog ? 'hideFullHistory' : 'showFullHistory')
          "
          @click="showInfoAboutActionLog"
        />
        <div class="container">
          <Button
            variant="filled"
            :title="$t('save')"
            @click="saveDescription"
          />
          <Button
            variant="notBordered"
            :title="$t('cancel')"
            @click="$emit('closeModal')"
          />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

import InfoAboutActionLog from './InfoAboutActionLog/InfoAboutActionLog.vue';
import GeneralInfoReservation from '@/duplicatePages/GeneralInfoReservation/GeneralInfoReservation.vue';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'AddDescription',
  props: ['showModal', 'activeDelivery', 'boxId', 'updateList'],
  emits: ['updateList', 'closeModal'],
  components: {
    InfoAboutActionLog,
    GeneralInfoReservation,
    Loading
  },
  data() {
    return {
      loading: false,
      showModalReservation: true,
      openInfoAboutActionLog: false,
      openGeneralInfoReservation: false,
      isAddDescription: false,
      formData: {
        reservedTime: 0,
        descriptionText: ''
      }
    };
  },
  methods: {
    ...mapActions('pharmacy', ['updateDescription']),
    async submitHandler() {
      this.loading = true;

      const deliveryId = this.activeDelivery?.deliveryId;

      const { id } = this.$route.params;

      if (this.boxId) {
        const payload = {
          descriptionText: this.activeDelivery.descriptionText,
          reservedTime: this.activeDelivery.reservedTime,
          pickupboxId: this.boxId,
          docId: this.activeDelivery.docId
        };
        await this.updateDescription({
          data: payload,
          deliveryId
        });
      } else {
        const payload = {
          descriptionText: this.activeDelivery.descriptionText,
          reservedTime: this.activeDelivery.reservedTime,
          pharmacyId: id,
          docId: this.activeDelivery.docId
        };
        await this.updateDescription({
          data: payload,
          deliveryId
        });
      }

      this.loading = false;
      this.$emit('updateList');

      this.$emit('closeModal');
    },
    saveDescription() {
      this.$formkit.submit('description-form');
    },
    showInfoAboutActionLog() {
      this.openInfoAboutActionLog = !this.openInfoAboutActionLog;
    }
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.openGeneralInfoReservation = true;
      }
    }
  }
})
export default class AddDescription extends Vue {}
</script>

<style lang="scss" scoped>
.addDescription {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .addDescription__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .addDescription__body {
    display: flex;
    flex-direction: column;
    .container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .addDescription__body-description {
        position: relative;
        width: 353px;
        height: 278px;
        margin-left: 16px;
        label {
          position: absolute;
          font-family: 'Ubuntu-Regular';
          top: -6px;
          left: 15px;
          padding: 0 5px;
          background: $white;
          color: $label;
          font-weight: 400;
          font-size: $twelveSize;
          line-height: $fourteenSize;
          z-index: 1;
        }
        textarea {
          width: 319px;
          height: 275px;
          padding: 16px;
          font-size: $fourteenSize;
          border: 1px solid $border;
          border-radius: 8px;
          resize: none;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .addDescription__buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>
